/**
 * LoginForm.js
 *
 * Copyright (c) apploft. GmbH
 */
import React from 'react';
import { useForm } from 'react-hook-form';
import Input from './Input';
import { stringMatching } from '../Theme';

function LoginForm(_ref) {
  var onSubmit = _ref.onSubmit,
      className = _ref.className,
      strings = _ref.strings;

  var _useForm = useForm(),
      register = _useForm.register,
      handleSubmit = _useForm.handleSubmit,
      errors = _useForm.errors;

  return React.createElement('form', {
    onSubmit: handleSubmit(onSubmit),
    className: className
  }, React.createElement('label', {
    className: 'fieldsetTitle'
  }, stringMatching(strings, 'Welcome')), Input({
    name: 'username',
    props: {
      required: true
    },
    errors: errors,
    register: register,
    type: 'text',
    defaultValue: null,
    strings: strings
  }), Input({
    name: 'password',
    // eslint-disable-next-line quote-props
    props: {
      required: true,
      'auto-complete': 'current-password'
    },
    errors: errors,
    register: register,
    type: 'password',
    defaultValue: null,
    strings: strings
  }), React.createElement('input', {
    type: 'submit',
    value: stringMatching(strings, 'login')
  }));
}

export default LoginForm;